export const CHANGE_CURRENT_QUIZ = "CHANGE_CURRENT_QUIZ" ;
export const UPDATE_CURRENT_QUIZ = "UPDATE_CURRENT_QUIZ" ;
